import {css} from 'lit';
export const styles = css`:host {
    --mdc-menu-min-width: 40px;
    display: inline-block;
}

iron-icon {
    color: var(--app-primary-color)
}`;
export default styles;
